import useSWR from 'swr'
import type { SWRConfiguration } from 'swr'

import useTemplateId from './useTemplateId'
import { config } from 'lib/config'
import { store } from 'lib/store'
import type { Header } from 'types/header'

export const useHeader = (options?: SWRConfiguration) => {
	const { withTemplateId } = useTemplateId()

	const { data, mutate, isLoading, error } = useSWR<Header>(withTemplateId(`${config.apiURL}/v1.0/header`), options)

	if (error) {
		store.dispatch({
			type: 'toast/set',
			payload: { kind: 'error', timeout: 6000, message: 'Something went wrong' },
		})
	}

	return {
		header: data,
		mutateHeader: mutate,
		isHeaderLoading: isLoading,
	}
}
